const GOOD_BAD_CATEGORY = {
  scalpIssue: {
    //TODO 탈모있음 내용 추가 필요
    HAIRLOSS: {
      good: ["BIOTIN_YEAST_BLACKBEAN", "ANTI_SEBORRHOEIC", "ANTIBACTERIA_DEODORANT"],
      bad: ["CHEMICAL_ANTISEPTIC", "SILICON", "CATIONIC_SURFACTANT", "UV_PROTECT"],
    },
    OILY_DANDRUFF: {
      good: ["ANTI_SEBORRHOEIC", "DANDRUFF_PREVENTION_AGENT", "SOFT_PHA", "STRONG_BHA"],
      bad: ["OIL"],
    },
    // ADD -> TODO:DELETE
    DANDRUFF: {
      good: ["ANTI_SEBORRHOEIC", "DANDRUFF_PREVENTION_AGENT", "STRONG_AHA"],
      bad: [],
    },
    // 각질
    DEAD_SKIN: {
      good: ["STRONG_AHA", "STRONG_BHA", "SOFT_PHA", "SOFT_LHA"],
      bad: ["FILM_FORMING", "PEG"],
    },
    // 두피열
    SCALP_FEVER: {
      good: ["ORGANIC_COOLING", "CHEMICAL_COOLING"],
      bad: ["PEG", "SILICON"],
    },
    DRY_DANDRUFF: {
      good: ["ANTI_SEBORRHOEIC", "DANDRUFF_PREVENTION_AGENT", "STRONG_AHA"],
      bad: [],
    },
    INFLAMMATION: {
      good: ["ANTI_SEBORRHOEIC", "ANTI_INFLAMMATION", "EMOLLIENT", "ANTIOXIDANT", "SKIN_PROTECTION"],
      bad: ["FILM", "SILICON_PEG", "PEG"],
    },
    PIMPLE: {
      good: ["ANTI_INFLAMMATION", "ANTI_SEBORRHOEIC", "EMOLLIENT"],
      bad: ["OIL", "FILM"],
    },
    ITCHING: {
      SENSITIVITY: {
        good: ["SOFT_PHA", "EMOLLIENT", "ANTI_SEBORRHOEIC"],
        bad: [],
      },
      OILY: { good: ["STRONG_BHA", "EMOLLIENT", "ANTI_SEBORRHOEIC"], bad: [] },
      DRY: {
        good: ["STRONG_AHA", "SOFT_PHA", "EMOLLIENT", "ANTI_SEBORRHOEIC"],
        bad: [],
      },
      GENERAL: {
        good: ["STRONG_AHA", "STRONG_BHA", "SOFT_PHA", "EMOLLIENT", "ANTI_SEBORRHOEIC"],
        bad: [],
      },
      SEBORRHEIC: {
        good: ["STRONG_AHA", "STRONG_BHA", "SOFT_PHA", "EMOLLIENT", "ANTI_SEBORRHOEIC"],
        bad: [],
      },
    },
    SENSITIVITY: {
      good: [
        "EMOLLIENT",
        "HUMECTANT",
        "ANIONIC_SURFACTANT_ORGANIC",
        "ANTIOXIDANT",
        "ANTI_INFLAMMATION",
        "AMINO_ACID",
        "ANTISEBORRHOEIC",
        "SKIN_PROTECTION",
        "BIOTIN_YEAST_BLACKBEAN",
      ],
      bad: [
        "STRONG_AHA",
        "STRONG_BHA",
        "ORGANIC_COOLING",
        "CATIONIC_SURFACTANT",
        "CHEMICAL_COOLING",
        "ANIONIC_SURFACTANT_MINUS",
        "ANIONIC_SURFACTANT",
      ],
    },
    GREASY: {
      good: ["ANTIBACTERIA_DEODORANT", "SOFT_PHA", "STRONG_BHA", "SEBUM_CONTROL", "ANTI_SEBORRHOEIC"],
      bad: ["OIL", "FILM"],
    },
    SEBUM: {
      good: ["SEBUM_CONTROL", "SOFT_PHA", "ANTIBACTERIA_DEODORANT", "ANTI_INFLAMMATION"],
      bad: [],
    },
    DRYNESS: {
      good: ["HUMECTANT", "EMOLLIENT", "OIL", "ANTIOXIDANT"],
      bad: ["STRONG_BHA", "CATIONIC_SURFACTANT", "ALCOHOL", "CHEMICAL_COOLING", "STRONG_AHA"],
    },
    SMELL: { good: ["ANTIBACTERIA_DEODORANT", "ANTI_SEBORRHOEIC"], bad: [] },
  },
  scalpType: {
    GENERAL: {
      good: [
        "ANTIOXIDANT",
        "ANIONIC_SURFACTANT_ORGANIC",
        "PHA",
        "BIOTIN_YEAST_BLACKBEAN",
        "HUMECTANT",
        "AMINO_ACID",
        "ANTI_SEBORRHOEIC",
        "ORGANIC_COOLING",
        "EMOLLIENT",
      ],
      bad: ["ANIONIC_SURFACTANT_MINUS"],
    },
    OILY: {
      good: [
        "BHA",
        "PHA",
        "ORGANIC_COOLING",
        "CHEMICAL_COOLING",
        "ANTI_INFLAMMATION",
        "BIOTIN_YEAST_BLACKBEAN",
        "DANDRUFF_PREVENTION_AGENT",
        "SEBUM_CONTROL",
        "ANTIBACTERIA_DEODORANT",
        "ANTI_SEBORRHOEIC",
        "ANIONIC_SURFACTANT",
        "ANIONIC_SURFACTANT_MINUS",
        "AMPHOTERIC_SURFACTANT",
      ],
      bad: ["OIL"],
    },
    DRY: {
      good: [
        "HUMECTANT",
        "ANIONIC_SURFACTANT_ORGANIC",
        "BIOTIN_YEAST_BLACKBEAN",
        "EMOLLIENT",
        "ANTIOXIDANT",
        "ANTI_SEBORRHOEIC",
        "AMINO_ACID",
        "SKIN_PROTECTION",
        "OIL",
      ],
      bad: ["BHA", "CATIONIC_SURFACTANT", "CHEMICAL_COOLING", "ANIONIC_SURFACTANT_MINUS"],
    },
    SENSITIVITY: {
      good: [
        "EMOLLIENT",
        "HUMECTANT",
        "ANIONIC_SURFACTANT_ORGANIC",
        "ANTIOXIDANT",
        "ANTI_INFLAMMATION",
        "AMINO_ACID",
        "ANTI_SEBORRHOEIC",
        "SKIN_PROTECTION",
        "BIOTIN_YEAST_BLACKBEAN",
      ],
      bad: [
        "AHA",
        "BHA",
        "ORGANIC_COOLING",
        "CATIONIC_SURFACTANT",
        "CHEMICAL_COOLING",
        "ANIONIC_SURFACTANT_MINUS",
        "ANIONIC_SURFACTANT",
      ],
    },
    SEBORRHEIC: {
      good: [
        "ANTI_SEBORRHOEIC",
        "ANTIBACTERIA_DEODORANT",
        "ANTI_INFLAMMATION",
        "BIOTIN_YEAST_BLACKBEAN",
        "ORGANIC_COOLING",
        "ANTIOXIDANT",
        "EMOLLIENT",
        "SKIN_PROTECTION",
        "AMINO_ACID",
        "AMPHOTERIC_SURFACTANT",
      ],
      bad: ["FILM", "UV_PROTECT", "CHEMICAL_COOLING", "ANIONIC_SURFACTANT_MINUS"],
    },
  },
  preferenceShampoo: {
    NATURAL: {
      good: [],
      bad: ["ANIONIC_SURFACTANT_MINUS", "CHEMICAL_ANTISEPTIC", "CHEMICAL_PIGMENT"],
    },
    COOLING: { good: ["ORGANIC_COOLING", "CHEMICAL_COOLING"], bad: [] },
    FRAGRANCE: { good: ["ORGANIC_FRAGRANCE", "ARTIFICIAL_FRAGRANCE"], bad: [] },
  },
  preferenceHair: {
    STIFF: { good: [], bad: ["FILM"] },
    SOFT: { good: ["FILM", "AMINO_ACID"], bad: [] },
  },
  lifestyle: {
    dyeing: { good: ["AMINO_ACID", "SKIN_PROTECTION"], bad: [] },
    perm: { good: ["AMINO_ACID", "SKIN_PROTECTION"], bad: [] },
  },
  common: {
    common: {
      good: ["HUMECTANT", "AMINO_ACID", "ANTISEBORRHOEIC", "ORGANIC_COOLING", "EMOLLIENT"],
      bad: ["SILICON", "PEG", "CHEMICAL_PIGMENT", "ANIONIC_SURFACTANT_MINUS", "CHEMICAL_ANTISEPTIC"],
    },
  },
};

// 두피고민 우선순위 3가지를 추출하고 이에 따른 유익한/피해야 할 성분 카테고리 알려주기
export const stateGoodBadCategory = (analysis) => {
  // cares ---> issue
  let issues = [];
  if (!analysis) return issues;

  const { scalp_type } = analysis.scalp_type === "DRY_AND_OILY" ? { ...analysis, scalp_type: "OILY" } : analysis;

  const handleScalpIssue = (key) => {
    if (key === "ITCHING") {
      // analysis.scalp_type
      issues.push({
        key: key,
        good: GOOD_BAD_CATEGORY.scalpIssue[key][scalp_type].good.slice(0, 5),
        bad: GOOD_BAD_CATEGORY.scalpIssue[key][scalp_type].bad.slice(0, 5),
        type: "scalpIssue",
      });
    } else {
      issues.push({
        key: key,
        good: GOOD_BAD_CATEGORY.scalpIssue[key]?.good.slice(0, 5),
        bad: GOOD_BAD_CATEGORY.scalpIssue[key]?.bad.slice(0, 5),
        type: "scalpIssue",
      });
    }
  };

  // 1. 메인 두피타입
  if (scalp_type) {
    issues.push({
      key: scalp_type,
      good: GOOD_BAD_CATEGORY.scalpType[scalp_type].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.scalpType[scalp_type].bad.slice(0, 5),
      type: "scalpType",
    });
  }
  // if (analysis.scalp_type_2) {
  //   const key = analysis.scalp_type_2;
  //   issues.push({
  //     key: key,
  //     good: GOOD_BAD_CATEGORY.scalpType[key].good.slice(0, 5),
  //     bad: GOOD_BAD_CATEGORY.scalpType[key].bad.slice(0, 5),
  //     type: "scalpType",
  //   });
  //   if (issues.length === 3) return issues;
  // }

  // 1. 두피고민 1~3
  analysis.scalp_issue?.issue_1 && handleScalpIssue(analysis.scalp_issue.issue_1);
  analysis.scalp_issue?.issue_2 && handleScalpIssue(analysis.scalp_issue.issue_2);
  if (analysis.scalp_issue?.issue_3) {
    handleScalpIssue(analysis.scalp_issue.issue_3);
    if (issues.length === 3) return issues;
  }

  // 3. 샴푸 선호도 1~2
  if (
    analysis.preference?.shampoo_1 &&
    Object.prototype.hasOwnProperty.call(GOOD_BAD_CATEGORY.preferenceShampoo, analysis.preference.shampoo_1)
  ) {
    const key = analysis.preference.shampoo_1;
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.preferenceShampoo[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.preferenceShampoo[key].bad.slice(0, 5),
      type: "preferenceShampoo",
    });
    if (issues.length === 3) return issues;
  }
  if (
    analysis.preference?.shampoo_2 &&
    Object.prototype.hasOwnProperty.call(GOOD_BAD_CATEGORY.preferenceShampoo, analysis.preference.shampoo_2)
  ) {
    const key = analysis.preference.shampoo_2;
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.preferenceShampoo[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.preferenceShampoo[key].bad.slice(0, 5),
      type: "preferenceShampoo",
    });
    if (issues.length === 3) return issues;
  }

  // 4. 머릿결 선호도 1
  if (analysis.preference?.hair_1) {
    const key = analysis.preference.hair_1;
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.preferenceHair[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.preferenceHair[key].bad.slice(0, 5),
      type: "preferenceHair",
    });
    if (issues.length === 3) return issues;
  }

  // 5. 생활습관
  if (analysis.lifestyle?.dyeing && analysis.lifestyle.dyeing !== null && analysis.lifestyle.dyeing !== "NONE") {
    const key = "dyeing";
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.lifestyle[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.lifestyle[key].bad.slice(0, 5),
      type: "lifestyle",
    });
    if (issues.length === 3) return issues;
  }
  if (analysis.lifestyle?.perm && analysis.lifestyle.perm !== null && analysis.lifestyle.perm !== "NONE") {
    const key = "perm";
    issues.push({
      key: key,
      good: GOOD_BAD_CATEGORY.lifestyle[key].good.slice(0, 5),
      bad: GOOD_BAD_CATEGORY.lifestyle[key].bad.slice(0, 5),
      type: "lifestyle",
    });
    if (issues.length === 3) return issues;
  }

  // 6. 공통성분
  const key = "common";
  issues.push({
    key: key,
    good: GOOD_BAD_CATEGORY.common[key].good.slice(0, 5),
    bad: GOOD_BAD_CATEGORY.common[key].bad.slice(0, 5),
    type: "common",
  });

  return issues;
};
